import { Pipe, PipeTransform } from '@angular/core';

import { areasSituacoes } from '../area-situacao';

@Pipe({
    name: 'areaSituacao'
})
export class AreaSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = areasSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return areasSituacoes[index].nome;
        }
        return '';
    }
}
